import React, { useEffect, useForm, useState,useRef } from 'react';
import ContentLoader from "react-content-loader";
import { isMobile, useForceUpdate } from '../../services/shared';

import Button from '../Button/Button';
import Checkbox from '../Checkbox/Checkbox';

import './Dealers.scss';
import ribbon from '../../assets/images/ribbon.png';

let dealersErrorMessage = "";
let oldDealerList = [];

let MAX_DEALER_SELECTION = 2;
let INITIAL_DEALER_SELECTION = 2;
const MIN_DEALER_SELECTION = 0;

const Dealers = ({
        dealersLoading = false,
        dealerList,
        isInvalidZipCode = false,
        zipCode,
        hideCTA,
        dealerCheckedHandler,
        dealerContinueActionHandler,
        bttnLoader,
        btnTxt,
        secondaryTxt,
        oem,
        make,
        model,
        allowScroll,
        matchingUtmContent,
        editZipCode=false, showDealerSelectionError,
                     setShowDealerSelectionError,
                     changedZip,
                     setChangedZip,
                     initialZipcode,
                     setInitialZipcode,
    }) => {

    const forceUpdate = useForceUpdate()
    // const params = new URLSearchParams();
    const params = new URLSearchParams(window.location.search);
    let searchParams = new URLSearchParams(window.location.search);

    const [ animateMaxDealerTxt, setAnimateMaxDealer ] = useState(false);

    // useEffect(()=>{
    //     if(dealerList.length){
    //         if(dealerList.length !== oldDealerList.length || !getSelectedDealers().length){
    //             oldDealerList = dealerList;
    //             setDefaultSelection(dealerList,Math.min(INITIAL_DEALER_SELECTION,dealerList.length))
    //         }
    //         forceUpdate();
    //     }
    // },[dealerList])
    const isFirstRender = useRef(true);

    useEffect(() => {
        // console.log('1st useeffect, default selection useffect getSelectedDealers()',getSelectedDealers(),getSelectedDealers().length)
        // console.log('!getSelectedDealers().length',!getSelectedDealers().length)
        // console.log('dealerList.length !== oldDealerList.length',dealerList.length !== oldDealerList.length)

        if (dealerList.length) {
               if (dealerList.length !== oldDealerList.length) {
                oldDealerList = dealerList;
                setDefaultSelection(dealerList, Math.min(INITIAL_DEALER_SELECTION, dealerList.length))

            }
            forceUpdate();
        }
        isFirstRender.current = false
    }, [dealerList, zipCode])
    useEffect(() => {
        oldDealerList = [];
    }, [zipCode])


    useEffect(()=>{
        if(oem === 'GM'){
            MAX_DEALER_SELECTION = 2;
            INITIAL_DEALER_SELECTION = 0;
        } else if(oem === 'Volkswagen'){
            MAX_DEALER_SELECTION = 5;
            INITIAL_DEALER_SELECTION = 3;
        } else if(oem === 'Nissan' || oem === 'Infiniti'){
            MAX_DEALER_SELECTION = 3;
            INITIAL_DEALER_SELECTION = 3;
        } else if(['Subaru','Volvo'].includes(oem)){
            MAX_DEALER_SELECTION = 2;
            INITIAL_DEALER_SELECTION = 2;
        }else if(['Honda', 'Alfa Romeo', 'BMW', 'Toyota', 'Hyundai', 'Maserati'].includes(oem)){
            MAX_DEALER_SELECTION = 4;
            INITIAL_DEALER_SELECTION = 0;
        }
        else if(['Hyundai','Dodge','Chrysler','RAM','Jeep','Genesis'].includes(oem)){
            MAX_DEALER_SELECTION = 2;
            INITIAL_DEALER_SELECTION = 0;
        } else if(['Kia', 'Audi'].includes(oem)){
            MAX_DEALER_SELECTION = 3;
            INITIAL_DEALER_SELECTION = 3;
        } else if(oem === 'Mitsubishi') {
            MAX_DEALER_SELECTION = 2;
            INITIAL_DEALER_SELECTION = 2;
        }
    },[oem])

    function isDisabledCheckbox(dealer) {
        let selectedDealers = getSelectedDealers();
        return (selectedDealers.length === MIN_DEALER_SELECTION && dealer.checked) || (selectedDealers.length === MAX_DEALER_SELECTION && !dealer.checked)
    }

    function getSelectedDealers(){
        return dealerList.filter(_=>_.checked);
    }

    function setDefaultSelection(dealers,n){
        for(let i=0;i<n;i++){
            dealers[i].checked = true;
        }
    }

    function animateDealerWarning() {
        let selectedDealers = getSelectedDealers();
        if(selectedDealers.length === MIN_DEALER_SELECTION){
            dealersErrorMessage = `Please select at least one dealer.`
        }
        if(selectedDealers.length === MAX_DEALER_SELECTION){
            dealersErrorMessage = `Please select only up to ${MAX_DEALER_SELECTION} dealers.`
        }
        setAnimateMaxDealer(true);
        setTimeout(() => {
            setAnimateMaxDealer(false);
        },1000);
    }
    useEffect(() => {
        if (showDealerSelectionError && getSelectedDealers().length === 0) {
            console.log('show error useeffexct')
            animateDealerWarning()
            if (window.innerWidth > 1025) {
                window.scrollTo(0, 0);
            }
        }
    }, [showDealerSelectionError, dealerList])
    // useEffect(() => {
    //     if (getSelectedDealers().length > 0) {
    //         setShowDealerSelectionError(false)
    //     }
    // }, [dealerList])
    

    return (
        <React.Fragment>
            {/* {( dealersLoading===false && dealerList.length > 0  && isInvalidZipCode===false && searchParams.get('tmpl')==='t3') ? <p style={{fontSize:"16px",fontWeight:800,marginBottom:"25px",lineHeight:"16px"}}>We've found dealers near you.</p>:<></>} */}
            {/*{ ( params.get('tmpl')=='t3') && <p style={{fontSize:"16px",lineHeight:"25px",fontWeight:800,color:"red"}}>We've found dealers near youuu.</p>}*/}
            {
                !dealersLoading && isInvalidZipCode  &&
                <div className={`no-dealers-message flex h-full items-center justify-center text-center ${editZipCode?'edit-zipcode':''}`}>
                    {/*<div>*/}
                    {/*    <div>Please enter a US zip code to find the best deals for a {make} {model}</div>*/}
                    {/*<br></br>*/}
                    {/*</div>*/}
                </div>
            }
            {/*{*/}
            {/*    !dealersLoading && dealerList.length > 0 && dealersErrorMessage && !isInvalidZipCode &&*/}
            {/*    <div className={"maxDealer-selected-warning " + ( animateMaxDealerTxt ? 'animate-warning-text' : '')}>{dealersErrorMessage}</div>*/}
            {/*}*/}
            {
                (showDealerSelectionError === true || (!dealersLoading && dealerList.length > 0 && dealersErrorMessage && !isInvalidZipCode) ) &&
                <div
                    className={"maxDealer-selected-warning " + (animateMaxDealerTxt ? 'animate-warning-text' : '')}>{dealersErrorMessage}</div>
            }
            {
                !dealersLoading && !dealerList.length > 0  && !isInvalidZipCode &&
                <div className={`no-dealers-message flex h-full items-center justify-center text-center ${editZipCode?'edit-zipcode':''}`}>
                    {/* <div>

                        {
                            window.location.pathname === '/deals_ae' ?
                                <div>Please enter your Zip to find the best deals for a {make} {model}</div> : (
                                    zipCode?
                                        <div className="nodealer-error-wrap"> 
                                            <svg className='nodealer-error-wrap_icon' xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                            <g opacity="0.5">
                                                <path d="M15.4352 5.79006L2.73015 27.0001C2.46821 27.4537 2.3296 27.968 2.32814 28.4918C2.32667 29.0157 2.46239 29.5308 2.72179 29.9858C2.9812 30.4409 3.35524 30.8202 3.80672 31.0858C4.25819 31.3515 4.77135 31.4943 5.29515 31.5001H30.7052C31.229 31.4943 31.7421 31.3515 32.1936 31.0858C32.6451 30.8202 33.0191 30.4409 33.2785 29.9858C33.5379 29.5308 33.6736 29.0157 33.6722 28.4918C33.6707 27.968 33.5321 27.4537 33.2702 27.0001L20.5652 5.79006C20.2977 5.34922 19.9212 4.98474 19.4719 4.73179C19.0227 4.47884 18.5158 4.34595 18.0002 4.34595C17.4846 4.34595 16.9776 4.47884 16.5284 4.73179C16.0791 4.98474 15.7026 5.34922 15.4352 5.79006V5.79006Z" stroke="#7C7F89" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                <path d="M18 13.5V19.5" stroke="#7C7F89" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                <path d="M18 25.5H18.0133" stroke="#7C7F89" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </g>
                                            </svg>
                                            <p className='nodealer-error-wrap_msg-bold'>Please enter another zip code</p>
                                            <p className='nodealer-error-wrap_msg-light'>There are no dealers located in this area</p>
                                        </div>
                                        :
                                        <div>Please enter your Zip to find the best deals for a {make} {model}</div>

                                )
                        }
                        <br></br>
                    </div> */}
                </div>
            }
            <div className={`dealer-list flex-auto ${allowScroll?'allow-scroll':''}`}>
                <ul >
                    {dealersLoading && window.location.pathname !== '/deals' && window.location.pathname !== '/deals_ae' ?
                    <div className="dealers-loading">
                        <ContentLoader
                            speed={2}
                            width={'100%'}
                            height={400}
                            viewBox="0 0 100% 600"
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                        >
                            <rect x="0" y="8" rx="3" ry="3" width="100%" height="10" />
                            <rect x="0" y="26" rx="3" ry="3" width="80%" height="10" />

                            <rect x="0" y="76" rx="3" ry="3" width="100%" height="10" />
                            <rect x="0" y="94" rx="3" ry="3" width="80%" height="10" />

                            <rect x="0" y="146" rx="3" ry="3" width="100%" height="10" />
                            <rect x="0" y="164" rx="3" ry="3" width="80%" height="10" />

                            <rect x="0" y="216" rx="3" ry="3" width="100%" height="10" />
                            <rect x="0" y="234" rx="3" ry="3" width="80%" height="10" />

                            <rect x="0" y="286" rx="3" ry="3" width="100%" height="10" />
                            <rect x="0" y="304" rx="3" ry="3" width="80%" height="10" />
                        </ContentLoader>
                    </div>
                    : dealerList.map((dealer,i)=>{
                        return (
                            <li className={"dealer-list-item"} key={i}  style={params.get('tmpl')==='t3'?{"position":"relative"}:{}} >
                                {/*{(params.get('tmpl')==='t3' && window.location.pathname === '/deals') ? <div className="ribbon"><img src={ribbon}/></div>:<></>}*/}

                                <label htmlFor={`dealer-${i}`} className={`flex items-center gcd-change-dealers ${dealer.checked?'checked':''}`} onClick={(e) =>{
                                    e.stopPropagation();
                                    if(isDisabledCheckbox(dealer)){
                                        animateDealerWarning();
                                    }else{
                                        dealer.checked = !dealer.checked;
                                        dealerCheckedHandler(dealer, i);
                                    }
                                }}>
                                    <Checkbox></Checkbox>
                                    <div className="flex flex-col w-full">
                                        <div className="flex items-center">
                                            <div className="dealer-name flex-auto">{dealer.name}</div>

                                        </div>

                                        <div className="flex">
                                            <div className="dealer-location">{dealer.address} {dealer.city}, {dealer.state} {dealer.postalCode}</div>
                                            <div className="distance flex-auto text-right">{Math.floor(dealer.distance) >1?Math.floor(dealer.distance)+' miles away':'less than 1 mile away'}</div>
                                        </div>
                                    </div>
                                </label>
                            </li>
                        )
                    })}
                </ul>
                {
                    (!dealersLoading && !hideCTA && zipCode) &&
                    // + ( windowSize < 1025 ? '' : 'd-none')
                    <div className={`field extra-top flex continue-with-dealers ${isMobile()?'sticky':''}`}>
                        <Button className="xl primary gcd-cta-one" loading={bttnLoader} onClick={dealerContinueActionHandler}>
                            <div>{ btnTxt || 'Get Started'}</div>
                            { secondaryTxt && <div className="secondary-text">{secondaryTxt}</div>}
                        </Button>
                    </div>
                }
            </div>

        </React.Fragment>
    )
}

export default Dealers;